import {
  createFileRoute,
  Outlet,
  ErrorComponentProps,
} from "@tanstack/react-router";
import AuthGuardCombined from "@/components/auth/auth-guard-combined";
import DashboardLayout from "@/components/layout/dashboard-layout";
import { ErrorComponent } from "@/components/errors/error-component";

export const Route = createFileRoute("/_authenticated")({
  component: AuthenticatedLayout,
  errorComponent: AuthenticatedErrorComponent,
});

function AuthenticatedErrorComponent({ error, reset }: ErrorComponentProps) {
  return (
    <AuthGuardCombined>
      <DashboardLayout basePath="/">
        <ErrorComponent
          error={error}
          reset={reset}
          context={{
            route: "/_authenticated",
          }}
        />
      </DashboardLayout>
    </AuthGuardCombined>
  );
}

function AuthenticatedLayout() {
  return (
    <AuthGuardCombined>
      <DashboardLayout basePath="/">
        <Outlet />
      </DashboardLayout>
    </AuthGuardCombined>
  );
}
